import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="till"
// synonyme de cash register
export default class extends Controller {
  static targets = [ "total", "lineItem"]
  
  lineItemTargetConnected(el) {
    this.run()
  }

  lineItemTargetDisconnected(el) {
    this.run()

    const correlationId = el.dataset.targetCorrelationId;

    document.querySelectorAll(`[data-correlation-id='${correlationId}']`).forEach((el)=>el.remove())
  }

  run() {
    // Les utilisateurs 'agent' n'ont pas de total à afficher
    if (!this.hasTotalTarget) {
      return
    }
    const totalAmount = this.lineItemTargets.reduce(
      (accumulator, el) =>  accumulator + parseFloat(el.dataset.amount),
      0.0
    )

    this.totalTarget.innerHTML = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(totalAmount)
  }
}
